import * as angular from "angular";
import {IController} from "angular";

export class PackagesTableComponent implements IController {
  itemsCount: any;
  items: any;

  constructor() {
  }
}

angular
  .module('bringoz.admin.commons')
  .component('packagesTable', {
    bindings: {
      itemsCount: '<',
      items: '<'
    },
    templateUrl: 'app/modules/commons/components/packages-table/packages-table.html',
    controller: PackagesTableComponent
  });
